import React from 'react';
import { NistFunctionPage } from '../../../components/assessment/nist/NistFunctionPage';
import { NIST_FUNCTIONS } from '../../../utils/nistAiRmf';
export function MeasureFunction() {
  const functionData = NIST_FUNCTIONS.find(f => f.id === 'Measure')!;
  return <NistFunctionPage functionId="Measure" title={functionData.title} description={functionData.description} nextPath="/assessment/nist/manage" prevPath="/assessment/nist/map" data-id="element-476" />;
}